<section
  class="flex w-full flex-col bg-[url('/assets/images/bg-orders.png')] bg-contain bg-top bg-no-repeat"
  (window:resize)="onWindowResize()"
>
  <app-orders-top></app-orders-top>

  <div class="flex min-h-[calc(100vh-439px)] flex-col gap-4 lg:flex-row">
    <section
      class="widget !mx-0 !mt-0 flex-1 rounded-t-2xl bg-white !shadow-lg max-lg:rounded-none lg:!ml-4"
    >
      <div
        class="sticky top-[80px] z-[3] rounded-t-2xl bg-white shadow-sm max-lg:rounded-none"
        #headerContainer
      >
        <div
          class="widget-header flex flex-wrap items-center justify-between gap-4 !pb-0"
        >
          <div class="flex items-center gap-2 text-[#0f2744]">
            <mat-icon>check_circle</mat-icon>
            <h1 class="text-2xl font-normal leading-tight max-[1375px]:text-xl">
              Order Status
            </h1>
          </div>

          <div class="flex items-center gap-4 text-sm">
            <a
              routerLink="/orders-table"
              title="View Orders List"
              class="flex items-center gap-2 text-[#18c1df] hover:underline"
            >
              <span class="text-sm font-normal">View Orders List</span>
              <mat-icon>assignment</mat-icon>
            </a>
            @if (formattedCSVData.length > 0) {
              <div class="csv-export flex items-center gap-2 text-[#18c1df]">
                <span class="text-sm font-normal">Download</span>
                <app-csv-download
                  [csvData]="formattedCSVData"
                  [fileName]="'Orders-Status.csv'"
                ></app-csv-download>
              </div>
            }
          </div>
        </div>

        @if (!(isLoading$ | async)) {
          <div
            class="widget-header flex flex-wrap items-center justify-between gap-4"
          >
            <div class="search-wrapper relative -mt-2 w-full">
              <mat-form-field class="w-full lg:w-2/5">
                <mat-icon matPrefix class="!pr-1">search</mat-icon>
                <input
                  matInput
                  class="!pl-0"
                  [formControl]="searchTermControl"
                  placeholder="Search"
                  autocomplete="on"
                />
              </mat-form-field>
            </div>
          </div>
        }
      </div>

      <div class="flex flex-col">
        @if (filteredOrders.length > 0) {
          @if (isLoading$ | async) {
            <div class="loading-indicator">
              <mat-spinner [diameter]="50"></mat-spinner>
            </div>
          } @else if (filteredOrders.length === 0) {
            <div>
              <div
                class="orders-empty w-full pt-8 text-center text-lg font-light text-[#0f2744]"
              >
                There are currently no pending orders.
              </div>
              <div class="mt-7 h-px w-full bg-gray-200"></div>
            </div>
          } @else {
            <mat-accordion class="gap flex flex-col">
              @for (
                order of filteredOrders | paginate: { itemsPerPage: 10, currentPage: page };
                track order.Id;
                let index = $index
              ) {
                <div class="rounded-lg bg-white/80 shadow-sm" id="ordersData">
                  <mat-expansion-panel class="bg-transparent shadow-none">
                    <mat-expansion-panel-header
                      [collapsedHeight]="'50px'"
                      class="matDescription border-b border-gray-200 !bg-gray-100 px-5 py-2"
                      (click)="
                        onSelect({
                          detailView: 'Order',
                          orderId: order.Id,
                          lineItemId: null,
                        })
                      "
                      (keyup.enter)="
                        onSelect({
                          detailView: 'Order',
                          orderId: order.Id,
                          lineItemId: null,
                        })
                      "
                      [class.selected]="
                        order.Id === (selectedOrderId$ | async) &&
                        (detailView$ | async) === viewsObject.order &&
                        browserSize !== 'small'
                      "
                    >
                      <mat-panel-description class="w-full">
                        <order-list-display
                          class="block w-full"
                          [order]="order"
                          [isSelected]="
                            order.Id === (selectedOrderId$ | async) &&
                            (detailView$ | async) === viewsObject.order
                          "
                        ></order-list-display>
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                    @for (
                      line of order.Customer_Order_OLI__r?.records;
                      track line.Id;
                      let lineIndex = $index
                    ) {
                      <div
                        class="border-b border-gray-200 outline-none transition focus-visible:ring-2 focus-visible:ring-[#0D62FF]"
                        tabindex="0"
                        (click)="
                          onSelect({
                            detailView: 'LineItem',
                            orderId: order.Id,
                            lineItemId: line.Id,
                          })
                        "
                        (keyup.enter)="
                          onSelect({
                            detailView: 'LineItem',
                            orderId: order.Id,
                            lineItemId: line.Id,
                          })
                        "
                        [class.selected]="
                          line.Id === (selectedLineItemId$ | async) &&
                          (detailView$ | async) === viewsObject.lineItem
                        "
                      >
                        <line-item-list-display
                          [order]="order"
                          [lineItem]="line"
                          [isSelected]="
                            line.Id === (selectedLineItemId$ | async) &&
                            (detailView$ | async) === viewsObject.lineItem
                          "
                        ></line-item-list-display>
                      </div>
                    }
                  </mat-expansion-panel>
                </div>
              }
            </mat-accordion>
          }
        }
        <pagination-controls
          (pageChange)="page = $event"
          [autoHide]="true"
          class="mt-6 flex justify-center"
        ></pagination-controls>
      </div>

      @if (browserSize === 'small') {
        <app-footer class="fixed bottom-0 w-full"></app-footer>
      }
    </section>

    @if (browserSize !== 'small') {
      <app-orders-detail-shell
        class="flex-1 rounded-tl-2xl bg-white shadow-lg"
        [detailView]="detailView$ | async"
      ></app-orders-detail-shell>
    }
  </div>
</section>
